var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18.085c.414 0 .75.338.75.755v1.011a1.899 1.899 0 0 1-2.4 1.83 58.989 58.989 0 0 0-15.6-2.087.752.752 0 0 1-.75-.753c0-.417.335-.755.75-.756a60.482 60.482 0 0 1 15.994 2.14c.256.07.506-.119.506-.374V18.84c0-.417.336-.755.75-.755zm-15.75-.754h-.375A1.88 1.88 0 0 1 1.5 15.445V5.636c0-1.041.84-1.886 1.875-1.886h17.25a1.88 1.88 0 0 1 1.87 1.739l.005.147v9.809c0 1.041-.84 1.886-1.875 1.886H3.75zM19.5 5.259h-15l-.007.145a1.505 1.505 0 0 1-1.349 1.357L3 6.768v7.545l.144.007c.714.068 1.281.64 1.35 1.357l.006.145h15c0-.784.595-1.429 1.356-1.502l.144-.007V6.768c-.828 0-1.5-.676-1.5-1.509zM12 6.768c2.071 0 3.75 1.689 3.75 3.772 0 2.084-1.679 3.773-3.75 3.773-2.071 0-3.75-1.689-3.75-3.773 0-2.083 1.679-3.772 3.75-3.772zm0 1.509a2.257 2.257 0 0 0-2.25 2.263A2.257 2.257 0 0 0 12 12.804a2.257 2.257 0 0 0 2.25-2.264A2.257 2.257 0 0 0 12 8.277z",
    fill: "#8E06BF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyPurple);
export default __webpack_public_path__ + "static/media/money-purple.28985521b61d50434b028a4142c968d3.svg";
export { ForwardRef as ReactComponent };